// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.organization-structure-container {
  padding: 20px;
  max-width: 1400px;
  margin: 0 auto;
}

.page-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 30px;
  padding-bottom: 20px;
  border-bottom: 2px solid #e9ecef;
}

.header-left h1 {
  margin: 0;
  font-size: 28px;
  color: #2c3e50;
}

.page-subtitle {
  margin: 5px 0 0 0;
  color: #6c757d;
  font-size: 14px;
}

.header-actions .btn {
  padding: 10px 20px;
  font-size: 14px;
}

/* Legend */
.org-legend {
  display: flex;
  gap: 30px;
  margin-bottom: 20px;
  padding: 15px 20px;
  background: #f8f9fa;
  border-radius: 8px;
  font-size: 14px;
}

.legend-item {
  display: flex;
  align-items: center;
  gap: 8px;
  color: #495057;
}

.legend-item i {
  font-size: 16px;
}

/* Filter Section */
.org-filter {
  display: flex;
  gap: 20px;
  margin-bottom: 20px;
  padding: 15px 20px;
  background: white;
  border-radius: 8px;
  border: 1px solid #e9ecef;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
  flex-wrap: wrap;
  align-items: flex-start;
}

.filter-group {
  display: flex;
  flex-direction: column;
  gap: 6px;
  flex: 1 1;
  min-width: 180px;
  max-width: 280px;
}

.filter-group label {
  font-weight: 500;
  color: #495057;
  font-size: 13px;
  white-space: nowrap;
}

.filter-autocomplete {
  position: relative;
  width: 100%;
}

.filter-search {
  width: 100%;
  padding: 8px 12px;
  padding-right: 36px;
  border: 1px solid #ced4da;
  border-radius: 6px;
  font-size: 14px;
  transition: border-color 0.2s ease;
  box-sizing: border-box;
}

.filter-search.has-selection {
  background-color: #e7f5ff;
  border-color: #74c0fc;
}

.filter-search:focus {
  outline: none;
  border-color: #80bdff;
  box-shadow: 0 0 0 3px rgba(0, 123, 255, 0.1);
}

.filter-clear-btn {
  position: absolute;
  right: 8px;
  top: 50%;
  transform: translateY(-50%);
  border: none;
  background: none;
  color: #6c757d;
  cursor: pointer;
  padding: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  transition: all 0.2s ease;
}

.filter-clear-btn:hover {
  background-color: #f8f9fa;
  color: #dc3545;
}

.filter-clear-all {
  display: flex;
  align-items: flex-end;
  min-width: auto;
  max-width: none;
}

.btn-clear-filter {
  padding: 8px 16px;
  font-size: 14px;
  display: flex;
  align-items: center;
  gap: 6px;
  white-space: nowrap;
  border: 1px solid #6c757d;
  background: white;
  color: #6c757d;
  border-radius: 6px;
  cursor: pointer;
  transition: all 0.2s ease;
}

.btn-clear-filter:hover {
  background: #6c757d;
  color: white;
}

.filter-dropdown {
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  margin-top: 4px;
  background: white;
  border: 1px solid #ced4da;
  border-radius: 6px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  z-index: 1000;
  max-height: 300px;
  overflow-y: auto;
}

.filter-dropdown-item {
  padding: 10px 12px;
  cursor: pointer;
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 12px;
  transition: background-color 0.2s ease;
}

.filter-dropdown-item:hover {
  background-color: #f8f9fa;
}

.filter-dropdown-item:active {
  background-color: #e9ecef;
}

.filter-item-info {
  flex: 1 1;
  min-width: 0;
}

.filter-item-name {
  display: block;
  font-size: 14px;
  color: #212529;
  font-weight: 500;
}

.filter-item-parent {
  display: block;
  font-size: 12px;
  color: #6c757d;
  margin-top: 2px;
}

.filter-item-type {
  font-size: 11px;
  padding: 2px 8px;
  border-radius: 4px;
  white-space: nowrap;
  font-weight: 500;
}

.filter-item-type.type-district {
  background-color: #e7f1ff;
  color: #0056b3;
}

.filter-item-type.type-zone {
  background-color: #d4edda;
  color: #155724;
}

.filter-item-type.type-group {
  background-color: #f8d7da;
  color: #721c24;
}

.filter-dropdown-empty {
  padding: 12px;
  text-align: center;
  color: #6c757d;
  font-size: 14px;
}

/* Organization Tree */
.organization-tree {
  background: white;
  border-radius: 12px;
  padding: 20px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

/* District, Zone, Group common styles */
.org-district,
.org-zone,
.org-group {
  margin-bottom: 15px;
  border: 2px solid #e9ecef;
  border-radius: 8px;
  background: white;
  transition: all 0.3s ease;
}

.org-district {
  border-color: #3498db;
  background: #f8fbff;
}

.org-zone {
  border-color: #2ecc71;
  background: #f8fff8;
  margin-left: 40px;
}

.org-group {
  border-color: #e74c3c;
  background: #fff8f8;
  margin-left: 40px;
}

.org-district:hover,
.org-zone:hover,
.org-group:hover {
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  transform: translateY(-2px);
}

/* Item Header */
.org-item-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px 12px;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
}

.org-item-info {
  display: flex;
  align-items: center;
  gap: 8px;
  flex: 1 1;
}

.org-item-info > i:first-child {
  color: #6c757d;
  font-size: 12px;
  width: 14px;
  transition: transform 0.3s ease;
}

.org-item-info > i:nth-child(2) {
  font-size: 16px;
}

.org-district .org-item-info > i:nth-child(2) {
  color: #3498db;
}

.org-zone .org-item-info > i:nth-child(2) {
  color: #2ecc71;
}

.org-group .org-item-info > i:nth-child(2) {
  color: #e74c3c;
}

.org-item-name {
  font-size: 16px;
  font-weight: 600;
  color: #2c3e50;
}

.org-badge {
  padding: 4px 12px;
  border-radius: 12px;
  font-size: 12px;
  font-weight: 500;
  background: #6c757d;
  color: white;
}

.district-badge {
  background: #3498db;
}

.zone-badge {
  background: #2ecc71;
}

.org-count {
  font-size: 13px;
  color: #6c757d;
  padding: 4px 10px;
  background: rgba(0, 0, 0, 0.05);
  border-radius: 12px;
}

/* Item Actions */
.org-item-actions {
  display: flex;
  gap: 4px;
}

.btn-icon {
  padding: 3px 6px;
  background: transparent;
  border: 1px solid #dee2e6;
  border-radius: 4px;
  cursor: pointer;
  color: #495057;
  font-size: 11px;
  transition: all 0.2s ease;
  display: inline-flex;
  align-items: center;
  gap: 4px;
  white-space: nowrap;
}

.btn-icon i {
  font-size: 10px;
}

.btn-icon:hover {
  background: #f8f9fa;
  border-color: #adb5bd;
}

.btn-icon.btn-add {
  background: #28a745;
  color: white;
  border-color: #28a745;
  padding: 3px 6px;
}

.btn-icon.btn-add:hover {
  background: #218838;
  border-color: #1e7e34;
}

.btn-icon.btn-edit {
  color: #2563eb;
  background: #eff6ff;
  border-color: transparent;
}

.btn-icon.btn-edit:hover {
  background: #dbeafe;
  color: #1e3a8a;
}

.btn-icon.btn-delete {
  color: #dc2626;
  background: #fef2f2;
  border-color: transparent;
}

.btn-icon.btn-delete:hover {
  background: #fee2e2;
  color: #991b1b;
}

.btn-icon.btn-manage {
  background: #eff6ff;
  color: #2563eb;
  border-color: transparent;
}

.btn-icon.btn-manage:hover {
  background: #dbeafe;
  color: #1e3a8a;
}

/* Item Details */
.org-item-details {
  padding: 0 20px 15px 48px;
  font-size: 14px;
}

.org-detail-item {
  margin-bottom: 8px;
}

.detail-label {
  color: #6c757d;
  margin-right: 8px;
  font-weight: 500;
}

.detail-value {
  color: #2c3e50;
  font-weight: 600;
}

/* Member Stats */
.org-member-stats {
  display: flex;
  gap: 20px;
  margin-top: 10px;
  padding: 10px;
  background: rgba(0, 0, 0, 0.03);
  border-radius: 6px;
}

.stat-item {
  display: flex;
  align-items: center;
  gap: 6px;
  color: #495057;
  font-size: 13px;
}

.stat-item i {
  color: #ffc107;
}

.stat-item.total {
  margin-left: auto;
  font-weight: 600;
  color: #2c3e50;
}

/* Group Member Names */
.group-member-names {
  margin-top: 10px;
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.group-member-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 6px 10px;
  background: #ffffff;
  border: 1px solid #e9ecef;
  border-radius: 6px;
}

.group-member-name {
  font-size: 13px;
  color: #2c3e50;
  font-weight: 500;
}

.group-member-remove {
  padding: 4px 8px;
  border-radius: 4px;
}

.group-member-remove i {
  font-size: 12px;
}

.group-member-empty {
  font-style: italic;
  font-size: 12px;
  color: #6c757d;
}

.group-member-section {
  background: #fefefe;
  border: 1px solid #eee;
  border-radius: 8px;
  padding: 8px 10px;
}

.group-member-section-heading {
  font-size: 12px;
  font-weight: 600;
  color: #4a4a4a;
  margin-bottom: 4px;
}

/* Children Container */
.org-children {
  padding: 15px 20px 5px 20px;
  animation: slideDown 0.3s ease;
}

@keyframes slideDown {
  from {
    opacity: 0;
    max-height: 0;
  }
  to {
    opacity: 1;
    max-height: 2000px;
  }
}

/* Empty States */
.empty-state {
  padding: 30px;
  text-align: center;
  color: #6c757d;
  font-size: 14px;
  font-style: italic;
}

.empty-state-large {
  padding: 60px 20px;
  text-align: center;
  color: #6c757d;
}

.empty-state-large i {
  font-size: 64px;
  color: #dee2e6;
  margin-bottom: 20px;
}

.empty-state-large p {
  font-size: 18px;
  margin-bottom: 20px;
}

/* Buttons */
.btn {
  padding: 8px 16px;
  border: none;
  border-radius: 6px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
  display: inline-flex;
  align-items: center;
  gap: 6px;
}

.btn-primary {
  background: #007bff;
  color: white;
}

.btn-primary:hover {
  background: #0056b3;
  box-shadow: 0 4px 8px rgba(0, 123, 255, 0.3);
}

.btn-secondary {
  background: #6c757d;
  color: white;
}

.btn-secondary:hover {
  background: #5a6268;
}

/* Loading */
.loading-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 60px;
  color: #6c757d;
}

.spinner-border {
  width: 48px;
  height: 48px;
  border: 4px solid #f3f3f3;
  border-top: 4px solid #3498db;
  border-radius: 50%;
  animation: spin 1s linear infinite;
  margin-bottom: 20px;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

/* Error Container */
.error-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 60px;
}

.error-message {
  color: #dc3545;
  font-size: 16px;
  margin-bottom: 20px;
}

/* Responsive */
@media (max-width: 768px) {
  .org-zone {
    margin-left: 20px;
  }
  
  .org-group {
    margin-left: 20px;
  }
  
  .org-member-stats {
    flex-direction: column;
    gap: 8px;
  }
  
  .stat-item.total {
    margin-left: 0;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/Organization/OrganizationStructure.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,oBAAoB;EACpB,gCAAgC;AAClC;;AAEA;EACE,SAAS;EACT,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,eAAe;AACjB;;AAEA,WAAW;AACX;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;EAClB,yBAAyB;EACzB,yCAAyC;EACzC,eAAe;EACf,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,SAAO;EACP,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,kCAAkC;EAClC,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,4CAA4C;AAC9C;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,2BAA2B;EAC3B,YAAY;EACZ,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;EACnB,yBAAyB;EACzB,iBAAiB;EACjB,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,QAAQ;EACR,eAAe;EACf,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,0CAA0C;EAC1C,aAAa;EACb,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,SAAS;EACT,sCAAsC;AACxC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,SAAO;EACP,YAAY;AACd;;AAEA;EACE,cAAc;EACd,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,cAAc;EACd,eAAe;AACjB;;AAEA,sBAAsB;AACtB;EACE,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;EACb,wCAAwC;AAC1C;;AAEA,wCAAwC;AACxC;;;EAGE,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;;;EAGE,0CAA0C;EAC1C,2BAA2B;AAC7B;;AAEA,gBAAgB;AAChB;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,iBAAiB;EACjB,eAAe;EACf,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,SAAO;AACT;;AAEA;EACE,cAAc;EACd,eAAe;EACf,WAAW;EACX,+BAA+B;AACjC;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,iBAAiB;EACjB,+BAA+B;EAC/B,mBAAmB;AACrB;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,eAAe;EACf,yBAAyB;EACzB,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA,iBAAiB;AACjB;EACE,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,SAAS;EACT,gBAAgB;EAChB,aAAa;EACb,+BAA+B;EAC/B,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;;AAEA,uBAAuB;AACvB;EACE,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,iBAAiB;EACjB,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,sBAAsB;EACtB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA,uBAAuB;AACvB;EACE,2BAA2B;EAC3B,8BAA8B;AAChC;;AAEA;EACE;IACE,UAAU;IACV,aAAa;EACf;EACA;IACE,UAAU;IACV,kBAAkB;EACpB;AACF;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA,YAAY;AACZ;EACE,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,4CAA4C;AAC9C;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA,YAAY;AACZ;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,6BAA6B;EAC7B,kBAAkB;EAClB,kCAAkC;EAClC,mBAAmB;AACrB;;AAEA;EACE,KAAK,uBAAuB,EAAE;EAC9B,OAAO,yBAAyB,EAAE;AACpC;;AAEA,oBAAoB;AACpB;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,cAAc;EACd,eAAe;EACf,mBAAmB;AACrB;;AAEA,eAAe;AACf;EACE;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,sBAAsB;IACtB,QAAQ;EACV;;EAEA;IACE,cAAc;EAChB;AACF","sourcesContent":[".organization-structure-container {\n  padding: 20px;\n  max-width: 1400px;\n  margin: 0 auto;\n}\n\n.page-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 30px;\n  padding-bottom: 20px;\n  border-bottom: 2px solid #e9ecef;\n}\n\n.header-left h1 {\n  margin: 0;\n  font-size: 28px;\n  color: #2c3e50;\n}\n\n.page-subtitle {\n  margin: 5px 0 0 0;\n  color: #6c757d;\n  font-size: 14px;\n}\n\n.header-actions .btn {\n  padding: 10px 20px;\n  font-size: 14px;\n}\n\n/* Legend */\n.org-legend {\n  display: flex;\n  gap: 30px;\n  margin-bottom: 20px;\n  padding: 15px 20px;\n  background: #f8f9fa;\n  border-radius: 8px;\n  font-size: 14px;\n}\n\n.legend-item {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  color: #495057;\n}\n\n.legend-item i {\n  font-size: 16px;\n}\n\n/* Filter Section */\n.org-filter {\n  display: flex;\n  gap: 20px;\n  margin-bottom: 20px;\n  padding: 15px 20px;\n  background: white;\n  border-radius: 8px;\n  border: 1px solid #e9ecef;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);\n  flex-wrap: wrap;\n  align-items: flex-start;\n}\n\n.filter-group {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n  flex: 1;\n  min-width: 180px;\n  max-width: 280px;\n}\n\n.filter-group label {\n  font-weight: 500;\n  color: #495057;\n  font-size: 13px;\n  white-space: nowrap;\n}\n\n.filter-autocomplete {\n  position: relative;\n  width: 100%;\n}\n\n.filter-search {\n  width: 100%;\n  padding: 8px 12px;\n  padding-right: 36px;\n  border: 1px solid #ced4da;\n  border-radius: 6px;\n  font-size: 14px;\n  transition: border-color 0.2s ease;\n  box-sizing: border-box;\n}\n\n.filter-search.has-selection {\n  background-color: #e7f5ff;\n  border-color: #74c0fc;\n}\n\n.filter-search:focus {\n  outline: none;\n  border-color: #80bdff;\n  box-shadow: 0 0 0 3px rgba(0, 123, 255, 0.1);\n}\n\n.filter-clear-btn {\n  position: absolute;\n  right: 8px;\n  top: 50%;\n  transform: translateY(-50%);\n  border: none;\n  background: none;\n  color: #6c757d;\n  cursor: pointer;\n  padding: 4px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 50%;\n  transition: all 0.2s ease;\n}\n\n.filter-clear-btn:hover {\n  background-color: #f8f9fa;\n  color: #dc3545;\n}\n\n.filter-clear-all {\n  display: flex;\n  align-items: flex-end;\n  min-width: auto;\n  max-width: none;\n}\n\n.btn-clear-filter {\n  padding: 8px 16px;\n  font-size: 14px;\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  white-space: nowrap;\n  border: 1px solid #6c757d;\n  background: white;\n  color: #6c757d;\n  border-radius: 6px;\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n.btn-clear-filter:hover {\n  background: #6c757d;\n  color: white;\n}\n\n.filter-dropdown {\n  position: absolute;\n  top: 100%;\n  left: 0;\n  right: 0;\n  margin-top: 4px;\n  background: white;\n  border: 1px solid #ced4da;\n  border-radius: 6px;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);\n  z-index: 1000;\n  max-height: 300px;\n  overflow-y: auto;\n}\n\n.filter-dropdown-item {\n  padding: 10px 12px;\n  cursor: pointer;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  gap: 12px;\n  transition: background-color 0.2s ease;\n}\n\n.filter-dropdown-item:hover {\n  background-color: #f8f9fa;\n}\n\n.filter-dropdown-item:active {\n  background-color: #e9ecef;\n}\n\n.filter-item-info {\n  flex: 1;\n  min-width: 0;\n}\n\n.filter-item-name {\n  display: block;\n  font-size: 14px;\n  color: #212529;\n  font-weight: 500;\n}\n\n.filter-item-parent {\n  display: block;\n  font-size: 12px;\n  color: #6c757d;\n  margin-top: 2px;\n}\n\n.filter-item-type {\n  font-size: 11px;\n  padding: 2px 8px;\n  border-radius: 4px;\n  white-space: nowrap;\n  font-weight: 500;\n}\n\n.filter-item-type.type-district {\n  background-color: #e7f1ff;\n  color: #0056b3;\n}\n\n.filter-item-type.type-zone {\n  background-color: #d4edda;\n  color: #155724;\n}\n\n.filter-item-type.type-group {\n  background-color: #f8d7da;\n  color: #721c24;\n}\n\n.filter-dropdown-empty {\n  padding: 12px;\n  text-align: center;\n  color: #6c757d;\n  font-size: 14px;\n}\n\n/* Organization Tree */\n.organization-tree {\n  background: white;\n  border-radius: 12px;\n  padding: 20px;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\n}\n\n/* District, Zone, Group common styles */\n.org-district,\n.org-zone,\n.org-group {\n  margin-bottom: 15px;\n  border: 2px solid #e9ecef;\n  border-radius: 8px;\n  background: white;\n  transition: all 0.3s ease;\n}\n\n.org-district {\n  border-color: #3498db;\n  background: #f8fbff;\n}\n\n.org-zone {\n  border-color: #2ecc71;\n  background: #f8fff8;\n  margin-left: 40px;\n}\n\n.org-group {\n  border-color: #e74c3c;\n  background: #fff8f8;\n  margin-left: 40px;\n}\n\n.org-district:hover,\n.org-zone:hover,\n.org-group:hover {\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);\n  transform: translateY(-2px);\n}\n\n/* Item Header */\n.org-item-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 8px 12px;\n  cursor: pointer;\n  user-select: none;\n}\n\n.org-item-info {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  flex: 1;\n}\n\n.org-item-info > i:first-child {\n  color: #6c757d;\n  font-size: 12px;\n  width: 14px;\n  transition: transform 0.3s ease;\n}\n\n.org-item-info > i:nth-child(2) {\n  font-size: 16px;\n}\n\n.org-district .org-item-info > i:nth-child(2) {\n  color: #3498db;\n}\n\n.org-zone .org-item-info > i:nth-child(2) {\n  color: #2ecc71;\n}\n\n.org-group .org-item-info > i:nth-child(2) {\n  color: #e74c3c;\n}\n\n.org-item-name {\n  font-size: 16px;\n  font-weight: 600;\n  color: #2c3e50;\n}\n\n.org-badge {\n  padding: 4px 12px;\n  border-radius: 12px;\n  font-size: 12px;\n  font-weight: 500;\n  background: #6c757d;\n  color: white;\n}\n\n.district-badge {\n  background: #3498db;\n}\n\n.zone-badge {\n  background: #2ecc71;\n}\n\n.org-count {\n  font-size: 13px;\n  color: #6c757d;\n  padding: 4px 10px;\n  background: rgba(0, 0, 0, 0.05);\n  border-radius: 12px;\n}\n\n/* Item Actions */\n.org-item-actions {\n  display: flex;\n  gap: 4px;\n}\n\n.btn-icon {\n  padding: 3px 6px;\n  background: transparent;\n  border: 1px solid #dee2e6;\n  border-radius: 4px;\n  cursor: pointer;\n  color: #495057;\n  font-size: 11px;\n  transition: all 0.2s ease;\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  white-space: nowrap;\n}\n\n.btn-icon i {\n  font-size: 10px;\n}\n\n.btn-icon:hover {\n  background: #f8f9fa;\n  border-color: #adb5bd;\n}\n\n.btn-icon.btn-add {\n  background: #28a745;\n  color: white;\n  border-color: #28a745;\n  padding: 3px 6px;\n}\n\n.btn-icon.btn-add:hover {\n  background: #218838;\n  border-color: #1e7e34;\n}\n\n.btn-icon.btn-edit {\n  color: #2563eb;\n  background: #eff6ff;\n  border-color: transparent;\n}\n\n.btn-icon.btn-edit:hover {\n  background: #dbeafe;\n  color: #1e3a8a;\n}\n\n.btn-icon.btn-delete {\n  color: #dc2626;\n  background: #fef2f2;\n  border-color: transparent;\n}\n\n.btn-icon.btn-delete:hover {\n  background: #fee2e2;\n  color: #991b1b;\n}\n\n.btn-icon.btn-manage {\n  background: #eff6ff;\n  color: #2563eb;\n  border-color: transparent;\n}\n\n.btn-icon.btn-manage:hover {\n  background: #dbeafe;\n  color: #1e3a8a;\n}\n\n/* Item Details */\n.org-item-details {\n  padding: 0 20px 15px 48px;\n  font-size: 14px;\n}\n\n.org-detail-item {\n  margin-bottom: 8px;\n}\n\n.detail-label {\n  color: #6c757d;\n  margin-right: 8px;\n  font-weight: 500;\n}\n\n.detail-value {\n  color: #2c3e50;\n  font-weight: 600;\n}\n\n/* Member Stats */\n.org-member-stats {\n  display: flex;\n  gap: 20px;\n  margin-top: 10px;\n  padding: 10px;\n  background: rgba(0, 0, 0, 0.03);\n  border-radius: 6px;\n}\n\n.stat-item {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  color: #495057;\n  font-size: 13px;\n}\n\n.stat-item i {\n  color: #ffc107;\n}\n\n.stat-item.total {\n  margin-left: auto;\n  font-weight: 600;\n  color: #2c3e50;\n}\n\n/* Group Member Names */\n.group-member-names {\n  margin-top: 10px;\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n\n.group-member-row {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 6px 10px;\n  background: #ffffff;\n  border: 1px solid #e9ecef;\n  border-radius: 6px;\n}\n\n.group-member-name {\n  font-size: 13px;\n  color: #2c3e50;\n  font-weight: 500;\n}\n\n.group-member-remove {\n  padding: 4px 8px;\n  border-radius: 4px;\n}\n\n.group-member-remove i {\n  font-size: 12px;\n}\n\n.group-member-empty {\n  font-style: italic;\n  font-size: 12px;\n  color: #6c757d;\n}\n\n.group-member-section {\n  background: #fefefe;\n  border: 1px solid #eee;\n  border-radius: 8px;\n  padding: 8px 10px;\n}\n\n.group-member-section-heading {\n  font-size: 12px;\n  font-weight: 600;\n  color: #4a4a4a;\n  margin-bottom: 4px;\n}\n\n/* Children Container */\n.org-children {\n  padding: 15px 20px 5px 20px;\n  animation: slideDown 0.3s ease;\n}\n\n@keyframes slideDown {\n  from {\n    opacity: 0;\n    max-height: 0;\n  }\n  to {\n    opacity: 1;\n    max-height: 2000px;\n  }\n}\n\n/* Empty States */\n.empty-state {\n  padding: 30px;\n  text-align: center;\n  color: #6c757d;\n  font-size: 14px;\n  font-style: italic;\n}\n\n.empty-state-large {\n  padding: 60px 20px;\n  text-align: center;\n  color: #6c757d;\n}\n\n.empty-state-large i {\n  font-size: 64px;\n  color: #dee2e6;\n  margin-bottom: 20px;\n}\n\n.empty-state-large p {\n  font-size: 18px;\n  margin-bottom: 20px;\n}\n\n/* Buttons */\n.btn {\n  padding: 8px 16px;\n  border: none;\n  border-radius: 6px;\n  font-size: 14px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n}\n\n.btn-primary {\n  background: #007bff;\n  color: white;\n}\n\n.btn-primary:hover {\n  background: #0056b3;\n  box-shadow: 0 4px 8px rgba(0, 123, 255, 0.3);\n}\n\n.btn-secondary {\n  background: #6c757d;\n  color: white;\n}\n\n.btn-secondary:hover {\n  background: #5a6268;\n}\n\n/* Loading */\n.loading-container {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 60px;\n  color: #6c757d;\n}\n\n.spinner-border {\n  width: 48px;\n  height: 48px;\n  border: 4px solid #f3f3f3;\n  border-top: 4px solid #3498db;\n  border-radius: 50%;\n  animation: spin 1s linear infinite;\n  margin-bottom: 20px;\n}\n\n@keyframes spin {\n  0% { transform: rotate(0deg); }\n  100% { transform: rotate(360deg); }\n}\n\n/* Error Container */\n.error-container {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 60px;\n}\n\n.error-message {\n  color: #dc3545;\n  font-size: 16px;\n  margin-bottom: 20px;\n}\n\n/* Responsive */\n@media (max-width: 768px) {\n  .org-zone {\n    margin-left: 20px;\n  }\n  \n  .org-group {\n    margin-left: 20px;\n  }\n  \n  .org-member-stats {\n    flex-direction: column;\n    gap: 8px;\n  }\n  \n  .stat-item.total {\n    margin-left: 0;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
